export const MAIL_IMPUESTOS_TO = process.env.REACT_APP_MAIL_IMPUESTOS_TO;
export const MAIL_IMPUESTOS_FROM = process.env.REACT_APP_MAIL_IMPUESTOS_FROM;
export const MAIL_IMPUESTOS_CC = process.env.REACT_APP_MAIL_IMPUESTOS_CC;

export const MENSAJESAPP = {
  LOGIN: {
    USUARIONOVALIDO: "Usuario y/o contraseña incorrectas.\n",
    ERRORALVALIDARUSUARIO: "Hubo un error al validar el usuario.\n"
  },
  FILTROS: {
    EXPEDIENTEINVALIDO: "El expediente ingresado no es válido, no se tendrá en cuenta para búsqueda."
  },
  VALIDACIONES: {
    FECHAFACTURA: "La fecha no puede ser mayor a la actual.",
    FECHAPAGO: "La fecha no puede ser menor o igual a la actual.",
    CONCEPTOIMPORTE: "Por favor, complete el concepto y el importe mayor a 0 antes de agregar",
    MONTOMAXIMOPAGO: "Monto máximo por liquidación: $99.999.999,99. Consultar con su referente judicial.",
    FECHAVTO: "Ingrese una fecha de vencimiento que sea mayor a la actual",
    DATOSINCOMPLETOSFORMAPAGO:"Faltan o no son válidos algunos datos en la forma de pago. Revise e ingrese la información necesaria"
  },
  DOCDIGITALIZADOS: {
    SECTORFACTURAJUICIO: "Legales/FacturasJuicio",
    SECTOROBSERVACIONES: "legales/sipe/documentos",
    AUTORFACTURAJUICIO: "Web Rect Liquidaciones Web",
    AUTOROBSERVACIONJUICIO: "Web Rect Observaciones Web",
    SELEECCIONARDOCUMENTO: "Por favor selecciona un documento.",
    SELEECCIONARTIPODOCUMENTO: "Por favor selecciona un tipo de documento.",
    SELEECCIONARTIPODOCUMENTOPDF: "Por favor selecciona un archivo PDF, que tenga extensión pdf en letra minuscula",
    SELEECCIONARDOCUMENTOOK: "Doumento adjunto correctamente.",
    SELECCIONARETAPA: "Debe seleccionar la Etapa antes de adjuntar archivos",
    CONFIRMARELIMINARDOC: "Esta seguro que desea eliminar el archivo adjunto?"
  },
  CONFIRMACION: {
    FACTURAENVIADAOK: "Factura enviada correctamente",
    OBSERVACOINENVIADAOK: "Observacion enviada correctamente",
    CANCELARCARGA: "¿Esta seguro que desea cancelar la carga?",
    ELIMINARPAGO: "`Esta seguro que desea eliminar el pago?",
    CORREOENVIADOOK: "Se envio el correo satisfactoriamente.",
    CONFIRMARSALIR: "¿Esta seguro que desea salir?"
  },
  ERRORES: {
    FACTURANOENVIADA: "No se pudo enviar la factura",
    OBSERVCIONNOENVIADA: "No se pudo enviar la observacion",
    FACTURAYAEXISTENTE: "El número de factura ingreso ya existe.",
    PAGOCONERROR: "Hubo un problema al grabar el pago correctamente",
    CONCEPTOYAEXISTENTE: "El número de factura ingreso ya existe.",
    CONCEPTOSNOEXISTENTES: "No se ha ingresado ningún concepto. Añada al menos uno para continuar",
    COMPROBANTENODISPONIBLE: "Comprobante no disponible. Solicitar comprobante de pago por mail a su referente administrativo.",
    ERRORENVIARCORREO: "Hubo un error en enviar el correo.",

  }
}

export const EstadosObservaciones = {
  INGRESADA: 1,
  APROBADA: 2,
  RECHAZADA: 3
};


export const EstadosFacturaLiquidacion = {
  PENDIENTE: 1,
  APROBADA: 2,
  RECHAZADA: 3,
  PENDIENTETL: 4,
  RECHAZADAAMODIFICAR: 5
};

const MapeoDeEstadosFactura = {
  1: 'Pendiente',
  2: 'Aprobada',
  3: 'Rechazada'
};

// Método para obtener el valor de cadena a partir del id
function obtenerEstado(valor) {
  const valorString = MapeoDeEstadosFactura[valor]
  return valorString
}

export { obtenerEstado }